(function() {
  'use strict';
 
  angular
    .module('qbePortal.routes')
    .run($run);
 
  var dataLayer = window.dataLayer = window.dataLayer || [];
 
  $run.$inject = ['$rootScope', '$state' , 'gtmService', 'quoteModelFactory'];

  /**
  * track virtual page views for all page.
  */ 
  function $run($rootScope, $state, gtmService, quoteModelFactory) {
 
    $rootScope.$on('$stateChangeSuccess', function() {
      gtmService.trackPageView($state.current, quoteModelFactory.create());
    });
 
  }
 
})(angular);
